import { type DELIVERY_METHOD, GROUP_KIND } from '@/types';

const DIRECTORY_MANAGED_GROUP_KINDS: GROUP_KIND[] = [GROUP_KIND.STAFF, GROUP_KIND.SCHOOL_STAFF];

export const isDirectoryManagedGroupKind = (kind: GROUP_KIND): boolean => DIRECTORY_MANAGED_GROUP_KINDS.includes(kind);

export const resolveGroupDeliveryMethods = (
  groupDeliveryMethods: DELIVERY_METHOD[],
  defaultDeliveryMethods?: DELIVERY_METHOD[]
): DELIVERY_METHOD[] => {
  if (groupDeliveryMethods.length > 0) {
    return groupDeliveryMethods;
  }

  return defaultDeliveryMethods?.length ? [...defaultDeliveryMethods] : [];
};

export const mergeGroupDeliveryMethodsIntoDefault = (
  groups: { deliveryMethods: DELIVERY_METHOD[] }[],
  defaultDeliveryMethods: DELIVERY_METHOD[]
): DELIVERY_METHOD[] => {
  const resolvedGroupMethods = groups.flatMap((group) =>
    resolveGroupDeliveryMethods(group.deliveryMethods, defaultDeliveryMethods)
  );

  const missingMethods = resolvedGroupMethods.filter((method) => !defaultDeliveryMethods.includes(method));

  if (missingMethods.length === 0) {
    return defaultDeliveryMethods;
  }

  return [...defaultDeliveryMethods, ...Array.from(new Set(missingMethods))];
};
